import 'lazysizes/lazysizes';
import 'lazysizes/plugins/rias/ls.rias';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.rias = window.lazySizesConfig.rias || {};
window.lazySizesConfig.rias.widths = [100, 203, 292, 616, 940];
